import React from 'react';
import PropTypes from 'prop-types';

import {
    Anchor,
    Text,
    Spacer,
} from '@zillow/constellation';
import { Center } from '@zillow/zrs-comet';

import StringConstants from 'app/shared/constants/StringConstants';

const BlockedUserModal = ({ brand }) => {
    const isZillow = () => brand === StringConstants.UNFORMATTED_BRAND_NAMES.zillow;

    const email = isZillow() ?
        'account_verification@zillow.com' :
        'account_verification@hotpads.com';

    const actionBrand = isZillow ?
        StringConstants.FORMATTED_BRAND_NAMES.zillow :
        StringConstants.FORMATTED_BRAND_NAMES.hotpads;

    return (
        <Center>
            <Spacer paddingBottom="md">
                <Text fontType="h6">Your account is currently disabled</Text>
            </Spacer>
            <Spacer paddingBottom="md">
                <Text fontType="body">
                    We are unable to access your properties at this time.
                    Please contact
                    {' '}
                    <Anchor href={`mailto:${email}`} escape={true}>{email}</Anchor>
                    {' '}
                    to resolve the issue.
                </Text>
            </Spacer>
            <Spacer marginBottom="sm">
                <Text fontType="body">
                    Return to
                    {' '}
                    <Anchor href={`https://www.${actionBrand.toLowerCase()}.com`}>{actionBrand}</Anchor>
                </Text>
            </Spacer>
        </Center>
    );
};

BlockedUserModal.propTypes = {
    brand: PropTypes.oneOf(Object.values(StringConstants.UNFORMATTED_BRAND_NAMES)).isRequired,
};

export default BlockedUserModal;
